import { Box, Button, Link, Step, StepLabel, Stepper } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useState } from "react";
import SlidingPanel from "react-sliding-side-panel";
import CloseIcon from "@mui/icons-material/Close";

// Defining Props interface for component
interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const EndorsementDetailPopup: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const steps = ["Active", "Inprogress", "Pending"];

  return (
    <>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        panelClassName="slidingPanel"
        // backdropClicked={() => value_update(attrName, false)}
      >
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid xs={10} className="headingTitle">
              <h3>
                <span>Endorsement Detail</span>
              </h3>
            </Grid>
            <Grid xs={2} textAlign="right">
              <Link
                className="closeIcon"
                onClick={() => {
                  value_update(attrName, false);
                }}
              >
                <CloseIcon />
              </Link>
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <Box className="scrollable_area">
            <Grid container spacing={3}>
              <Grid xs={12}>
                <Stepper activeStep={1} alternativeLabel>
                  {steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
                {/* <ul className="status_data">
                  <li>
                    <div className="circle">
                      <span className="active">Active</span>
                    </div>
                  </li>
                  <li>
                    <div className="circle">
                      <span className="pending">Pending</span>
                    </div>
                  </li>
                  <li>
                    <div className="circle">
                      <span className="rejected">Rejected</span>
                    </div>
                  </li>
                  <li>
                    <div className="circle">
                      <span className="inprogress">Inprogress</span>
                    </div>
                  </li>
                </ul> */}
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Client Id
                  <span>EV 005 - Evervent</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Member Id
                  <span>EV 065 - Vikas Saini</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Policy Number <span>PROH89346794567454</span>
                </p>
              </Grid>

              <Grid xs={6}>
                <p className="health_ecard">
                  Endorsement Value
                  <span>Address</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Endorsement Type
                  <span>Non Commercial Endorsement</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Old Value: <span>Female</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  New Value: <span>Male</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Policy Id
                  <span>PB152412- Group Health</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Insurer
                  <span>Reliance General Insurance</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Old Personal Address
                  <span>
                    Next57,341,phase 9, Industrial area Mohali, Punjab, India,{" "}
                  </span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Building/Street Name
                  <span>Next62,345,phase 9,</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Area Name
                  <span> Industrial area</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  Country
                  <span>India</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  State
                  <span>UK</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  City
                  <span>Dehradun</span>
                </p>
              </Grid>
              <Grid xs={6}>
                <p className="health_ecard">
                  ZipCode
                  <span>248142</span>
                </p>
              </Grid>
            </Grid>
          </Box>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {}}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </>
      </SlidingPanel>
    </>
  );
};

export default EndorsementDetailPopup;
